// Pure helpers for the B6 workspace file browser (list + table).
// No DOM, no React — exposed to app.jsx via window.mindexBrowse
// (see _lib/vendor.entry.js). A FileRow is:
//   { path, name, dir, size, lines, mtime, tags: string[], links_in, links_out }
// Behavior mirrors docs/mockups/2026-06-14-read-surface/script.js (browseRows).

export function defaultBrowseState() {
  return { view: 'list', filter: '', tags: [], tagMode: 'all', sort: 'mtime', dir: -1 };
}

export function filterRows(rows, { filter, tags, tagMode }) {
  const q = (filter || '').toLowerCase();
  const sel = tags || [];
  return rows.filter((r) => {
    if (sel.length) {
      const ok = tagMode === 'all'
        ? sel.every((t) => r.tags.includes(t))
        : sel.some((t) => r.tags.includes(t));
      if (!ok) return false;
    }
    if (q) {
      return (r.name + ' ' + r.dir).toLowerCase().includes(q);
    }
    return true;
  });
}

export function tagCounts(rows) {
  const m = new Map();
  for (const r of rows) {
    for (const t of r.tags) m.set(t, (m.get(t) || 0) + 1);
  }
  return [...m.entries()]
    .map(([tag, count]) => ({ tag, count }))
    .sort((a, b) => a.tag.localeCompare(b.tag));
}

// Sort a copy of `rows` by column `sort` in direction `dir` (1 asc, -1 desc).
// String columns (name, dir, path) use localeCompare; `tags` sorts by length;
// everything else is numeric. Ties break on `path` ascending for stability.
export function sortRows(rows, { sort, dir }) {
  return rows.slice().sort((a, b) => {
    let av;
    let bv;
    if (sort === 'tags') { av = a.tags.length; bv = b.tags.length; }
    else { av = a[sort]; bv = b[sort]; }
    let cmp;
    if (typeof av === 'string') cmp = av.localeCompare(bv);
    else cmp = av - bv;
    if (cmp !== 0) return dir * cmp;
    // Stable tie-break: always ascending by path, independent of `d`.
    return a.path.localeCompare(b.path);
  });
}
